const ProvidersTypes = {
    MODDO: 'moddo',
    ONLIVE: 'onlive',
    SHOPIFY: "shopify-private",
}

export default ProvidersTypes;